export default "__VITE_ASSET__DWT2aRGE__"